"use client";
import useNotificationText from "@workspace/casino_pages/legacyLayer/client/hooks/useNotificationText";
import Img from "@workspace/casino_pages/legacyLayer/legacyUi/Img";
import Content from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content";
import handleMarkAsRead from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/graphql/handleMarkAsRead";
import useHandleNotificationClick from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/useHandleNotificationClick";

const NormalNotification: FC<NotificationViewProps> = ({
  notification,
  onClose,
  context,
}) => {
  const handleClose = () => {
    if (notification.type === "normal") {
      handleMarkAsRead(notification.data);
    }
    onClose();
  };

  const { handleCloseNotificationClick, handleNotificationClick } =
    useHandleNotificationClick({
      context,
      notification: notification.data,
      onClose: handleClose,
    });

  const { title, body, isLoading } = useNotificationText({
    title: notification.data?.title,
    body: notification.data?.body,
    notificationId: notification.data?.id,
  });

  const notificationTitle = title.replaceAll("\u00A0", " ");

  if (!notification.data || isLoading) {
    return null;
  }

  return (
    <Content
      testId={`${notification.type}-notification`}
      onClose={handleCloseNotificationClick}
    >
      <div
        className="grid cursor-pointer gap-2 pt-6 ltr:text-left rtl:text-right"
        onClick={handleNotificationClick}
      >
        {notification.data.icon && (
          <Img width={48} src={notification.data.icon} alt={""} height={48} />
        )}
        <h4 className="text-lg/6 font-medium text-black">
          {notificationTitle}
        </h4>
        <p
          className="text-sm/6 text-muted-foreground"
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </div>
    </Content>
  );
};

export default NormalNotification;
